import { render, staticRenderFns } from "./AssetCategoryTable.vue?vue&type=template&id=6dee26ff&scoped=true&"
import script from "./AssetCategoryTable.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetCategoryTable.vue?vue&type=style&index=0&id=6dee26ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee26ff",
  null
  
)

export default component.exports